import { render, staticRenderFns } from "./index.vue?vue&type=template&id=674d93fa&scoped=true&"
import script from "./uploadImage.js?vue&type=script&lang=js&"
export * from "./uploadImage.js?vue&type=script&lang=js&"
import style0 from "./uploadImage.scss?vue&type=style&index=0&id=674d93fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d93fa",
  null
  
)

export default component.exports